// extracted by mini-css-extract-plugin
module.exports = {"splashImage":"PlasmicAccordionSectionSplashImage_splashImage__LazAN"};